import { useTranslate } from "#src/hooks";
import { Collapse } from "antd";
import { PaletteResponse } from "pages/media/types/";
import styled from "styled-components";
import { BrandkitPresets } from "./BrandkitPresets";

export const MainColorsSelect = ({
  palette,
  onColorClick,
  showCollapse = true,
}: {
  palette: PaletteResponse;
  onColorClick: (color: string) => void;
  showCollapse?: boolean;
}) => {
  const t = useTranslate();
  if (!showCollapse) {
    return <BrandkitPresets palette={palette} onColorClick={onColorClick} />;
  }
  return (
    <StyledCollapse
      ghost
      style={{
        fontSize: 12,
      }}
      items={[
        {
          key: "1",
          label: t("components.templates.settings.colorPicker.brandkitColors"),
          children: (
            <BrandkitPresets
              palette={palette}
              onColorClick={onColorClick}
              containerStyle={{ maxWidth: 180 }}
              itemStyle={{ width: "100%" }}
            />
          ),
        },
      ]}
    />
  );
};

const StyledCollapse = styled(Collapse)`
  .ant-collapse-header {
    padding: 0 !important;
  }
  .ant-collapse-content-box {
    padding: 8px 0 !important;
  }

  /* Match Ant's preset collapse expand icon */
  .ant-collapse-expand-icon {
    padding: 0 !important;
    padding-inline-end: 4px !important;
    color: rgba(60, 60, 60, 0.25) !important;
  }
`;
